"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-4">
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="mx-auto">
      <NavigationMenuList className="flex-wrap gap-4">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-fast)] ease-[var(--ease-smooth)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer ref={ref} className={`w-full bg-dark-background text-foreground-dark py-8 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-foreground-dark/70 text-center md:text-left">
            © {new Date().getFullYear()} Click Viral. All rights reserved.
          </div>

          <MenuProvider menu_id="9" className="flex-shrink-0">
            <FooterMenuConsumer />
          </MenuProvider>

          <div className="flex items-center gap-3">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab className="text-foreground-dark/60 hover:text-foreground-dark opacity-60 hover:opacity-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label={social.label} data-index={i}>
                  <Icon className="w-5 h-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}